import { AttributeCheck, type } from 'type-r';

export default type( null ).parse(v => {
    if (v && typeof v == 'string') {
        return JSON.parse(v);
    }
    else
        return v;
});
